import React from 'react';

export const isKetchLink = (href: string) => /[?&]ketch_show=/i.test(href);

export const cleanCountryLink = (href: string) => {
    if (!/[?&]cc=/i.test(href)) return href;
    const [path, hash] = href.split('#');
    const [base, query = ''] = path.split('?');
    const params = new URLSearchParams(query);
    params.delete('cc');
    const remaining = params.toString();
    return base + (remaining ? `?${remaining}` : '') + (hash ? `#${hash}` : '');
};

const PrivacyButton: React.FC<{
    children: React.ReactNode;
    className?: string;
}> = ({ children, className }) => (
    <button
        type="button"
        className={className}
        onClick={() => {
            try {
                if (
                    (window as any).ketchLoaded &&
                    typeof window.ketch === 'function'
                ) {
                    window.ketch('showExperience');
                    return;
                }
            } catch (_) {
                // The privacy request page remains available if Ketch throws.
            }
            window.location.assign('/ccpa-privacy-request/');
        }}
    >
        {children}
    </button>
);

export default PrivacyButton;
